import {PatientDetailsPage} from '@/modules/patients/components/patient-details/patient-details-page'
import {createFileRoute} from '@tanstack/react-router'
import * as z from 'zod'

const SearchSchema = z.object({
  tab: z.string().default('about'),
})

export const Route = createFileRoute('/patient-dashboard/patients/$patientId')({
  component: RouteComponent,
  validateSearch: SearchSchema,
})

function RouteComponent() {
  const {patientId} = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <PatientDetailsPage
      patientId={patientId}
      initialTab={search.tab}
      onTabChange={value => navigate({to: '.', search: prev => ({...prev, tab: value})})}
    />
  )
}
